import { createFileRoute } from '@tanstack/react-router'
import { ClientDocumentTypesSettings } from '@/features/organizations/settings/client-document-types'

export const Route = createFileRoute(
  '/_authenticated/_organization/organizations/settings/client-document-types'
)({
  component: ClientDocumentTypesSettings,
})

